const DEFAULT_ROLES = Object.freeze({})

export const parseRoles = (supportAccountIds, selectedAccount = 0) => (
  supportAccountIds?.[selectedAccount]?.rbacRoles || DEFAULT_ROLES
)

const roles = (state = DEFAULT_ROLES, action) => {
  switch (action.type) {
    case 'FETCH_CREDENTIALS_SUCCESS': {
      const { selectedAccount } = action
      const { supportAccountIds } = action.data.credentials || {}
      return parseRoles(supportAccountIds, selectedAccount)
    }
    case 'UPDATE_ROLES': {
      const { supportAccountIds, selectedAccount } = action.data || {}
      return parseRoles(supportAccountIds, selectedAccount)
    }
    default:
      return state
  }
}
export default roles
